import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { useState, useRef } from "react";
import Lightbox from "../components/detailProduct/zoomImg";

export default function Evenement() {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [loaded, setLoaded] = useState(false);

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    loop: true,
    created: () => setLoaded(true),
    slides: { perView: 1, spacing: 12 },
    breakpoints: {
      "(min-width: 640px)": { slides: { perView: 2, spacing: 18 } },
      "(min-width: 1024px)": { slides: { perView: 3, spacing: 24 } },
    },
  });

  const [lbIdx, setLbIdx] = useState<number | null>(null);
  const openLb = (i: number) => setLbIdx(i);
  const closeLb = () => setLbIdx(null);

  // liste de visuels
  const pictures = [
    "/images/event/expo/cinq_juillet/1.jpg",
    "/images/event/expo/cinq_juillet/2.jpg",
    "/images/event/expo/cinq_juillet/3.jpg",
    "/images/event/expo/cinq_juillet/4.jpg",
    "/images/event/expo/cinq_juillet/5.jpg",
    "/images/event/expo/cinq_juillet/6.jpg",
    "/images/event/expo/cinq_juillet/7.jpg",
    "/images/event/expo/cinq_juillet/8.jpg",
  ];

  const credits = [
    { name: "lilasdth", url: "https://www.instagram.com/lilasdth" },
    { name: "_qapictures_", url: "https://www.instagram.com/_qapictures_" },
  ];

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      videoRef.current.volume = 0.5;
    }
  };

  return (
    <section className="space-y-10 pb-16">
      {/* ——— Titre ——— */}
      <h1 className="mt-8 text-center text-3xl md:text-5xl font-semibold tracking-wide">
        Retour sur l'exposition du 5 juillet
      </h1>

      <div className="relative px-4 overflow-visible z-0">
        <div ref={sliderRef} className="keen-slider">
          {pictures.map((src, i) => (
            <div key={i} className="keen-slider__slide">
              <img
                src={src}
                alt={`Expo photo ${i + 1}`}
                onClick={() => openLb(i)}
                className="w-full h-72 md:h-96 rounded-xl shadow-lg cursor-zoom-in"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {loaded && (
          <>
            <button
              aria-label="Image précédente"
              className="absolute top-1/2 -translate-y-1/2 left-2 md:left-5
                         bg-black/20 hover:bg-black text-white/50 hover:text-white p-2 rounded-full backdrop-blur
                         transition focus:outline-none"
              onClick={() => instanceRef.current?.prev()}
            >
              <ChevronLeft />
            </button>

            <button
              aria-label="Image suivante"
              className="absolute top-1/2 -translate-y-1/2 right-2 md:right-5
                         bg-black/20 hover:bg-black text-white/50 hover:text-white p-2 rounded-full backdrop-blur
                         transition focus:outline-none"
              onClick={() => instanceRef.current?.next()}
            >
              <ChevronRight />
            </button>
          </>
        )}
      </div>

      {/* <div className="mx-auto w-full max-w-4xl px-4 relative z-10">
        <div className="aspect-video rounded-xl overflow-hidden shadow-lg">
          <iframe
            src={`https://photos.google.com/share/AF1QipNYyMy3oumTNtM4lWoW2jt_XVGoUjR0BY19RU7lNACgTvbNUqLkcCSOOItE-76f3w?key=d21LY3h6RzFZbVlJTTVhc242YllidHVwenFQQnpB`}
            allow="autoplay; fullscreen"
            className="w-full h-full"
            title="Vidéo"
          />
        </div>
      </div> */}
      <div className="mx-auto max-w-md md:max-w-none mt-8">
        <h3 className="text-center text-lg font-semibold mb-4">
          Photos &amp; vidéo&nbsp;:
        </h3>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6">
          {credits.map(({ name, url }) => (
            <a
              key={name}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm hover:underline"
            >
              {/* logo Insta (outline, même que le reste du site) */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <circle cx="12" cy="12" r="4" />
                <circle
                  cx="17"
                  cy="7"
                  r="1"
                  fill="currentColor"
                  stroke="none"
                />
              </svg>

              <span className="font-medium">@{name}</span>
            </a>
          ))}
        </div>
      </div>
      {lbIdx !== null && (
        <Lightbox images={pictures} openIdx={lbIdx} onClose={closeLb} />
      )}
    </section>
  );
}

const ChevronLeft = () => (
  <svg
    viewBox="0 0 24 24"
    className="w-5 h-5"
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
  >
    <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const ChevronRight = () => (
  <svg
    viewBox="0 0 24 24"
    className="w-5 h-5"
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
  >
    <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
